import { render } from "./LeftNav.vue?vue&type=template&id=2520c75e&scoped=true"
import script from "./LeftNav.vue?vue&type=script&lang=js"
export * from "./LeftNav.vue?vue&type=script&lang=js"

import "./LeftNav.vue?vue&type=style&index=0&id=2520c75e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2520c75e"]])

export default __exports__